const UK_DRIVER_LICENSES_TYPES = ['Full', 'Provisional', 'EU', 'International'] as const;

export default UK_DRIVER_LICENSES_TYPES;
